var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.deviceId !== 'PC')?_c('router-view'):_vm._e(),(_vm.deviceId === 'PC')?_c('div',{staticClass:"screen-orientation"},[_vm._v("请使用移动设备登录！")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }